import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { initProviderDiscovery } from './libs/wallet/EIP6963';

import './index.css';

initProviderDiscovery();

const loadingScreen = document.getElementById('loading-screen');
if (loadingScreen) {
  loadingScreen.remove();
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root is missing in the root environment');
}

createRoot(root).render(<App />);
